import { inject, Injectable } from "@angular/core";
import { SyncStore } from "../../storage/sync-store/sync-store";
import { SyncStoreUpdateBatchWeighing } from "../../storage/sync-store/update-data/sync-store-update-batch-weighing";
import { SyncStoreSaveData } from "../../storage/sync-store/update-data/sync-store-save-data";
import { SyncStoreUpdateAnimalWeighing } from "../../storage/sync-store/update-data/sync-store-update-animal-weighing";
import { SyncStoreUpdateRemoval } from "../../storage/sync-store/update-data/sync-store-update-removal";

@Injectable({
  providedIn: 'root',
})
export class SyncStoreReader {
  private readonly store = inject(SyncStore);

  constructor() {}

  getAnimalWeighings(): SyncStoreSaveData<SyncStoreUpdateAnimalWeighing>[] {
    return this.store.getAnimalWeighings();
  }
  getBatchWeighing(): SyncStoreSaveData<SyncStoreUpdateBatchWeighing>[] {
    return this.store.getBatchWeighings();
  }
  getRemovals(): SyncStoreSaveData<SyncStoreUpdateRemoval>[] {
    return this.store.getRemovals();
  }
}